import Callback from './Callback';
export default Callback;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/Callback/index.js